<c-form-field class="select__form-field" [control]="control" [showErrors]="showError" [focused]="isOpen">
  @if (label) {
    <div class="select__label">{{ label }}</div>
  }

  <div class="select__box" cFieldBox [id]="'open-modal-' + id">
    @if (displayedValue$ | async; as displayedValue) {
      <span class="select__value">{{ displayedValue }}</span>
    } @else {
      <span class="select__value select__value--placeholder">{{ placeholder }}</span>
    }
    @if (loading) {
      <c-spinner class="select__icon" [loading]="loading" />
    } @else {
      <c-icon class="select__icon" [icon]="icon" />
    }
  </div>

  <c-field-message [helpText]="helpText" />
</c-form-field>

<ion-modal
  [trigger]="'open-modal-' + id"
  [breakpoints]="[0, 0.5, 1]"
  [initialBreakpoint]="0.5"
  [handle]="false"
  (willPresent)="isOpen = true"
  (didDismiss)="isOpen = false"
  >
  <ng-template>
    <c-select-modal
      [options]="options"
      [label]="label"
      [enableSearch]="enableSearch"
      [noResultsLabel]="noResultsLabel"
      [selectedValue]="control?.value"
      (select)="onSelect($event)"
      (close)="closeModal()"
      />
  </ng-template>
</ion-modal>
